module.exports = __webpack_public_path__ + "img/action-comment.d8dab438.svg";